<template>
	<div class="message-display">
		<span v-if="noMessage" class="no-message">No messages</span>
		<div v-else>
			<ul v-chat-scroll>
				<message-list-item
					v-for="message in messages"
					:key="message.id"
					:members="members"
					:message="message"
				></message-list-item>
			</ul>
		</div>
	</div>
</template>

<script>
import MessageListItem from "./GroupsMessageListItem";

export default {
	data() {
		return {
			noMessage: true
		};
	},
	props: {
		messages: {
			type: Array
		},
		members: {
			type: Array
		}
	},
	components: {
		MessageListItem
	},
	beforeDestroy() {
		this.noMessage = true;
	},
	watch: {
		messages(val) {
			if (val.length > 0) {
				this.noMessage = false;
			} else {
				this.noMessage = true;
			}
		}
	}
};
</script>

<style scoped>
.message-display {
	/* height: 450px; */
	height: 70%;
	max-height: 700px;
	overflow: auto;
	margin: 10px 0px;
}

.no-message {
	display: block;
	text-align: center;
	color: #b7b7b7;
	font-size: 11px;
	margin-top: 15px;
	margin-bottom: 15px;
}

@media only screen and (max-width: 540px) {
	.message-display {
		/* max-height: 360px; */
		height: 65%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/groups/groupsMessage/GroupsMessageDisplay.vue